import axios from 'axios';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Resolve CSRF for Axios. Prefer the meta tag; fall back to SSR bootstrap
 * (window.__APP_DATA__.csrfToken). Silent when neither exists (e.g. map embed).
 */
export function applyAxiosCsrfToken() {
    if (typeof document === 'undefined') return;

    const fromMeta = document.head
        ?.querySelector('meta[name="csrf-token"]')
        ?.getAttribute('content');
    const fromBootstrap =
        typeof window !== 'undefined' && window.__APP_DATA__?.csrfToken
            ? String(window.__APP_DATA__.csrfToken)
            : '';
    const token = (fromMeta && fromMeta.trim()) || (fromBootstrap && fromBootstrap.trim()) || '';

    if (token) {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
    }
}

applyAxiosCsrfToken();
